/* ============================================================

   K.NOAH — LIVE DESIGN EXPORT V4

   Desktop + Mobile Safari / iPhone

   ============================================================ */



(function () {



  'use strict';





  /* ============================================================

     GUARD

     ============================================================ */



  if (window.KN_LIVE_EXPORT_V4) {

    return;

  }



  window.KN_LIVE_EXPORT_V4 = true;





  /* ============================================================

     SETTINGS

     ============================================================ */



  var HTML_TO_IMAGE_URL =

    'https://cdnjs.cloudflare.com/ajax/libs/html-to-image/1.11.11/html-to-image.min.js';



  var TRANSPARENT_PIXEL =

    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';



  var FINAL_WIDTH = 1455;

  var FINAL_HEIGHT = 2048;

  var FINAL_PADDING = 45;





  /* ============================================================

     DEVICE CHECK

     ============================================================ */



  function knIsMobileDownload() {



    return (

      window.matchMedia('(max-width: 900px)').matches ||

      /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

    );



  }





  /* ============================================================

     LOAD HTML-TO-IMAGE

     ============================================================ */



  function loadHtmlToImage() {



    return new Promise(function (resolve, reject) {



      if (window.htmlToImage) {



        resolve(window.htmlToImage);

        return;



      }





      var existing =

        document.querySelector(

          'script[data-kn-html-to-image]'

        );





      if (existing) {



        existing.addEventListener(

          'load',

          function () {



            if (window.htmlToImage) {



              resolve(window.htmlToImage);



            } else {



              reject(

                new Error(

                  'html-to-image not available.'

                )

              );



            }



          }

        );





        existing.addEventListener(

          'error',

          function () {



            reject(

              new Error(

                'html-to-image could not be loaded.'

              )

            );



          }

        );



        return;



      }





      var script =

        document.createElement('script');





      script.src =

        HTML_TO_IMAGE_URL;



      script.async =

        true;



      script.dataset.knHtmlToImage =

        '1';





      script.onload =

        function () {



          if (window.htmlToImage) {



            resolve(window.htmlToImage);



          } else {



            reject(

              new Error(

                'html-to-image could not be loaded.'

              )

            );



          }



        };





      script.onerror =

        function () {



          reject(

            new Error(

              'html-to-image could not be loaded.'

            )

          );



        };





      document.head.appendChild(

        script

      );



    });



  }





  /* ============================================================

     DOWNLOAD ICON

     ============================================================ */



  function downloadIcon() {



    return (

      '<svg viewBox="0 0 24 24" aria-hidden="true">' +



        '<path ' +

          'd="M12 3v12" ' +

          'fill="none" ' +

          'stroke="currentColor" ' +

          'stroke-width="2" ' +

          'stroke-linecap="round"/>' +



        '<path ' +

          'd="M7.5 10.5 12 15l4.5-4.5" ' +

          'fill="none" ' +

          'stroke="currentColor" ' +

          'stroke-width="2" ' +

          'stroke-linecap="round" ' +

          'stroke-linejoin="round"/>' +



        '<path ' +

          'd="M5 20h14" ' +

          'fill="none" ' +

          'stroke="currentColor" ' +

          'stroke-width="2" ' +

          'stroke-linecap="round"/>' +



      '</svg>'

    );



  }





  /* ============================================================

     CREATE BUTTON

     ============================================================ */



  function createButton(type) {



    var button =

      document.createElement('button');





    button.type =

      'button';



    button.className =

      'kn-live-download';



    button.dataset.knDownload =

      type;





    button.setAttribute(

      'aria-label',

      'Download ' + type + ' design'

    );





    button.setAttribute(

      'title',

      'Download Design'

    );





    button.innerHTML =

      downloadIcon() +

      '<span>DOWNLOAD</span>';





    return button;



  }





  /* ============================================================

     DESKTOP SAVE

     ============================================================ */



  function saveFile(

    dataUrl,

    fileName

  ) {



    var link =

      document.createElement('a');





    link.href =

      dataUrl;



    link.download =

      fileName;





    document.body.appendChild(

      link

    );





    link.click();



    link.remove();



  }





  /* ============================================================

     MOBILE WINDOW

     ============================================================ */



  function knOpenMobileDownloadWindow() {



    if (!knIsMobileDownload()) {

      return null;

    }





    /*

      IMPORTANT:

      This happens immediately during the original click.

      Safari therefore sees this as a user action.

    */



    var downloadWindow =

      window.open(

        '',

        '_blank'

      );





    if (!downloadWindow) {

      return null;

    }





    try {



      downloadWindow.document.open();





      downloadWindow.document.write(`



        <!doctype html>



        <html>



          <head>



            <meta

              name="viewport"

              content="width=device-width, initial-scale=1"

            >



            <meta

              name="theme-color"

              content="#f2f2f0"

            >



            <title>

              K.NOAH Design

            </title>



            <style>



              *{

                box-sizing:border-box;

              }



              html,

              body{

                margin:0;

                padding:0;

                width:100%;

                min-height:100%;

              }



              body{

                display:flex;

                align-items:center;

                justify-content:center;



                min-height:100vh;



                padding:30px;



                background:#f2f2f0;



                color:#111;



                font-family:

                  Arial,

                  Helvetica,

                  sans-serif;

              }



              .kn-mobile-loading{

                width:100%;

                max-width:340px;

                text-align:center;

              }



              .kn-mobile-spinner{

                width:34px;

                height:34px;



                margin:0 auto 20px;



                border:3px solid #d7d7d4;

                border-top-color:#111;



                border-radius:50%;



                animation:

                  knspin .7s linear infinite;

              }



              .kn-mobile-loading strong{

                display:block;



                margin-bottom:7px;



                font-size:18px;

                line-height:1.2;

                font-weight:800;

              }



              .kn-mobile-loading span{

                display:block;



                font-size:13px;

                line-height:1.5;



                color:#777;

              }



              @keyframes knspin{



                from{

                  transform:rotate(0deg);

                }



                to{

                  transform:rotate(360deg);

                }



              }



            </style>



          </head>



          <body>



            <div class="kn-mobile-loading">



              <div class="kn-mobile-spinner"></div>



              <strong>

                Creating your design...

              </strong>



              <span>

                Your PNG will appear here automatically.

              </span>



            </div>



          </body>



        </html>



      `);





      downloadWindow.document.close();



    } catch (error) {



      console.error(

        'K.NOAH MOBILE WINDOW:',

        error

      );



    }





    return downloadWindow;



  }





  /* ============================================================

     MOBILE RESULT PAGE

     ============================================================ */



  function knShowMobileImage(
    downloadWindow,
    dataUrl,
    fileName
  ) {

    function dataUrlToBlob(data) {

      try {

        var parts =
          data.split(',');

        var mimeMatch =
          parts[0].match(/data:([^;]+)/);

        var mime =
          mimeMatch
            ? mimeMatch[1]
            : 'image/png';

        var binary =
          atob(parts[1]);

        var bytes =
          new Uint8Array(
            binary.length
          );


        for (
          var i = 0;
          i < binary.length;
          i++
        ) {

          bytes[i] =
            binary.charCodeAt(i);

        }


        return new Blob(
          [bytes],
          {
            type: mime
          }
        );


      } catch (error) {


        console.error(
          'K.NOAH MOBILE BLOB:',
          error
        );


        return null;

      }

    }





    var blob =
      dataUrlToBlob(
        dataUrl
      );


    var imageUrl =
      blob
        ? URL.createObjectURL(blob)
        : dataUrl;





    /*
      IMPORTANT:

      NEVER replace the configurator page.

      If Safari blocked the initially opened
      download window, we first try the
      native mobile Share Sheet.
    */

    if (
      !downloadWindow ||
      downloadWindow.closed
    ) {


      if (
        blob &&
        navigator.share &&
        navigator.canShare
      ) {


        try {


          var fallbackFile =
            new File(

              [blob],

              fileName ||
              'KNOAH-DESIGN.png',

              {
                type:
                  'image/png'
              }

            );





          if (
            navigator.canShare({
              files: [
                fallbackFile
              ]
            })
          ) {


            navigator.share({

              files: [
                fallbackFile
              ],

              title:
                'K.NOAH Design'

            }).catch(
              function () {}
            );


            return;

          }


        } catch (shareError) {


          console.error(
            'K.NOAH MOBILE SHARE FALLBACK:',
            shareError
          );


        }

      }





      /*
        Second fallback:

        Try opening the finished image
        in another tab.

        The configurator itself remains untouched.
      */

      var fallbackWindow =
        window.open(
          imageUrl,
          '_blank'
        );





      if (!fallbackWindow) {


        /*
          Final safe fallback:

          Trigger an anchor download.

          Again:
          DO NOT navigate the configurator.
        */

        var fallbackLink =
          document.createElement(
            'a'
          );


        fallbackLink.href =
          imageUrl;


        fallbackLink.download =
          fileName ||
          'KNOAH-DESIGN.png';


        fallbackLink.target =
          '_blank';


        fallbackLink.rel =
          'noopener';


        document.body.appendChild(
          fallbackLink
        );


        fallbackLink.click();


        fallbackLink.remove();

      }


      return;

    }





    /*
      NORMAL MOBILE FLOW

      The result window was already opened
      synchronously during the original click.

      We now replace the loading page inside
      THAT WINDOW only.
    */

    try {


      var doc =
        downloadWindow.document;





      doc.open();





      doc.write(`

        <!doctype html>

        <html>

          <head>

            <meta
              name="viewport"
              content="width=device-width, initial-scale=1, maximum-scale=5"
            >

            <meta
              name="theme-color"
              content="#f2f2f0"
            >

            <title>
              K.NOAH Design
            </title>


            <style>

              *{
                box-sizing:border-box;
              }


              html,
              body{

                margin:0;
                padding:0;

                width:100%;
                min-height:100%;

                background:#f2f2f0;

              }


              body{

                min-height:100vh;

                padding:
                  18px 14px 40px;

                color:#111;

                font-family:
                  Arial,
                  Helvetica,
                  sans-serif;

              }


              .kn-mobile-page{

                width:100%;
                max-width:760px;

                margin:0 auto;

              }


              .kn-mobile-header{

                margin-bottom:14px;

                padding:18px;

                border:
                  1px solid #dededb;

                border-radius:12px;

                background:#fff;

              }


              .kn-mobile-kicker{

                display:block;

                margin-bottom:7px;

                font-size:9px;
                line-height:1;

                font-weight:900;

                letter-spacing:.14em;

                color:#999;

              }


              .kn-mobile-header strong{

                display:block;

                margin-bottom:7px;

                font-size:20px;
                line-height:1.1;

                font-weight:900;

                letter-spacing:-.02em;

              }


              .kn-mobile-header p{

                margin:0;

                font-size:12px;
                line-height:1.5;

                color:#777;

              }


              .kn-mobile-actions{

                display:grid;

                grid-template-columns:
                  1fr;

                gap:9px;

                margin-bottom:14px;

              }


              .kn-mobile-save{

                display:flex;

                align-items:center;
                justify-content:space-between;

                width:100%;
                min-height:54px;

                padding:
                  0 18px;

                border:0;

                border-radius:10px;

                background:#111;

                color:#fff;

                font-family:
                  Arial,
                  Helvetica,
                  sans-serif;

                font-size:11px;
                line-height:1;

                font-weight:900;

                letter-spacing:.06em;

                cursor:pointer;

              }


              .kn-mobile-save span:last-child{

                font-size:18px;

                font-weight:400;

              }


              .kn-mobile-image{

                overflow:hidden;

                width:100%;

                border:
                  1px solid #dededb;

                border-radius:12px;

                background:#e9e9e7;

              }


              .kn-mobile-image img{

                display:block;

                width:100%;
                max-width:100%;

                height:auto;

                margin:0 auto;

                -webkit-touch-callout:
                  default;

                -webkit-user-select:
                  auto;

                user-select:
                  auto;

              }


              .kn-mobile-tip{

                margin:
                  13px 4px 0;

                text-align:center;

                font-size:11px;
                line-height:1.5;

                color:#888;

              }

            </style>

          </head>


          <body>


            <main class="kn-mobile-page">


              <header class="kn-mobile-header">


                <span class="kn-mobile-kicker">

                  K.NOAH UNIFORM CONFIGURATOR

                </span>


                <strong>

                  YOUR DESIGN IS READY.

                </strong>


                <p>

                  Save or share your finished PNG.
                  You can also press and hold the image below.

                </p>


              </header>





              <div class="kn-mobile-actions">


                <button
                  type="button"
                  class="kn-mobile-save"
                  id="kn-mobile-share"
                >


                  <span>

                    SAVE / SHARE PNG

                  </span>


                  <span>

                    →

                  </span>


                </button>


              </div>





              <div class="kn-mobile-image">


                <img
                  id="kn-final-design"
                  alt="K.NOAH Uniform Design"
                >


              </div>





              <p class="kn-mobile-tip">

                iPhone: Press and hold the image and choose
                “Save to Photos” if you prefer.

              </p>


            </main>


          </body>

        </html>

      `);





      doc.close();





      /*
        Put finished image into result page.
      */

      var image =
        doc.getElementById(
          'kn-final-design'
        );


      if (image) {

        image.src =
          imageUrl;

      }





      /*
        SAVE / SHARE BUTTON
      */

      var shareButton =
        doc.getElementById(
          'kn-mobile-share'
        );





      if (shareButton) {


        shareButton.addEventListener(

          'click',

          async function () {


            try {


              var shareBlob =
                blob ||
                await (
                  await fetch(
                    dataUrl
                  )
                ).blob();





              var file =
                new File(

                  [shareBlob],

                  fileName ||
                  'KNOAH-DESIGN.png',

                  {
                    type:
                      'image/png'
                  }

                );





              /*
                iPhone / Android native
                share sheet.
              */

              if (

                downloadWindow.navigator.share &&

                downloadWindow.navigator.canShare &&

                downloadWindow.navigator.canShare({
                  files: [
                    file
                  ]
                })

              ) {


                await downloadWindow.navigator.share({

                  files: [
                    file
                  ],

                  title:
                    'K.NOAH Design'

                });


                return;

              }





              /*
                Browser fallback.
              */

              var link =
                doc.createElement(
                  'a'
                );


              link.href =
                imageUrl;


              link.download =
                fileName ||
                'KNOAH-DESIGN.png';


              link.target =
                '_blank';


              link.rel =
                'noopener';


              doc.body.appendChild(
                link
              );


              link.click();


              link.remove();





            } catch (error) {


              console.error(
                'K.NOAH MOBILE SHARE:',
                error
              );


            }


          }

        );


      }





    } catch (error) {


      console.error(
        'K.NOAH MOBILE RESULT:',
        error
      );





      /*
        IMPORTANT:

        Only the already opened result tab
        is allowed to navigate.

        NEVER use:
        window.location.href = dataUrl

        because that would replace the
        configurator itself.
      */

      try {


        downloadWindow.location.href =
          imageUrl;


      } catch (fallbackError) {


        console.error(
          'K.NOAH MOBILE RESULT FALLBACK:',
          fallbackError
        );


      }


    }


  }





  /* ============================================================

     MOBILE ERROR PAGE

     ============================================================ */



  function knShowMobileError(

    downloadWindow

  ) {



    if (

      !downloadWindow ||

      downloadWindow.closed

    ) {

      return;

    }





    try {      downloadWindow.document.open();





      downloadWindow.document.write(`



        <!doctype html>



        <html>



          <head>



            <meta

              name="viewport"

              content="width=device-width, initial-scale=1"

            >



            <title>

              K.NOAH Design

            </title>



            <style>



              *{

                box-sizing:border-box;

              }



              body{

                margin:0;



                display:flex;

                align-items:center;

                justify-content:center;



                min-height:100vh;



                padding:30px;



                background:#f2f2f0;



                color:#111;



                font-family:

                  Arial,

                  Helvetica,

                  sans-serif;



                text-align:center;

              }



              div{

                max-width:320px;

              }



              strong{

                display:block;



                margin-bottom:8px;



                font-size:18px;

              }



              span{

                font-size:13px;

                line-height:1.5;



                color:#777;

              }



            </style>



          </head>



          <body>



            <div>



              <strong>

                Design could not be created.

              </strong>



              <span>

                Please return to the configurator and try again.

              </span>



            </div>



          </body>



        </html>



      `);





      downloadWindow.document.close();



    } catch (error) {



      /* no further action */



    }



  }





  /* ============================================================

     NEXT PAINT

     ============================================================ */



  function nextPaint() {



    return new Promise(

      function (resolve) {



        requestAnimationFrame(

          function () {



            requestAnimationFrame(

              resolve

            );



          }

        );



      }

    );



  }





  /* ============================================================

     CHECK IMAGE

     ============================================================ */



  function imageIsBroken(img) {



    if (!img) {

      return true;

    }





    var src =

      img.getAttribute('src') ||

      img.currentSrc ||

      '';





    if (!src) {

      return true;

    }





    if (

      src ===

      window.location.href

    ) {

      return true;

    }





    if (

      img.complete &&

      img.naturalWidth === 0

    ) {

      return true;

    }





    return false;



  }





  /* ============================================================

     NEUTRALIZE BROKEN OPTIONAL IMAGES

     ============================================================ */



  function neutralizeBrokenImages(root) {



    var states = [];





    if (!root) {



      return function () {};



    }





    root

      .querySelectorAll('img')

      .forEach(

        function (img) {



          if (

            !imageIsBroken(img)

          ) {

            return;

          }





          states.push({



            img: img,



            src:

              img.getAttribute('src'),



            srcset:

              img.getAttribute('srcset'),



            sizes:

              img.getAttribute('sizes')



          });





          img.removeAttribute(

            'srcset'

          );





          img.removeAttribute(

            'sizes'

          );





          img.setAttribute(

            'src',

            TRANSPARENT_PIXEL

          );



        }

      );





    return function restoreImages() {



      states.forEach(

        function (state) {



          if (

            state.src === null

          ) {



            state.img.removeAttribute(

              'src'

            );



          } else {



            state.img.setAttribute(

              'src',

              state.src

            );



          }





          if (

            state.srcset === null

          ) {



            state.img.removeAttribute(

              'srcset'

            );



          } else {



            state.img.setAttribute(

              'srcset',

              state.srcset

            );



          }





          if (

            state.sizes === null

          ) {



            state.img.removeAttribute(

              'sizes'

            );



          } else {



            state.img.setAttribute(

              'sizes',

              state.sizes

            );



          }



        }

      );



    };



  }





  /* ============================================================

     EXPORT FILTER

     ============================================================ */



  function exportFilter(node) {



    if (!node) {

      return true;

    }





    if (

      node.classList &&

      node.classList.contains(

        'kn-live-download'

      )

    ) {

      return false;

    }





    if (

      node.tagName &&

      node.tagName.toLowerCase() ===

      'img'

    ) {



      var src =

        node.getAttribute('src') ||

        node.currentSrc ||

        '';





      if (!src) {

        return false;

      }



    }





    return true;



  }





  /* ============================================================

     GET JERSEY CANVAS

     ============================================================ */



  function getJerseyCanvas() {



    var root =

      document.getElementById(

        'frx-configurator'

      );





    if (!root) {

      return null;

    }





    return root.querySelector(

      '.frx-canvas'

    );



  }





  /* ============================================================

     GET PANTS CANVAS

     ============================================================ */



  function getPantsCanvas() {



    return document.getElementById(

      'kn-pants-canvas'

    );



  }





  /* ============================================================

     LOAD RENDERED IMAGE

     ============================================================ */



  function loadRenderedImage(

    dataUrl

  ) {



    return new Promise(

      function (

        resolve,

        reject

      ) {



        var image =

          new Image();





        image.onload =

          function () {



            resolve(image);



          };





        image.onerror =

          function (error) {



            reject(error);



          };





        image.src =

          dataUrl;



      }

    );



  }





  /* ============================================================

     EXPORT CANVAS

     ============================================================ */



  async function exportCanvas(

    canvas,

    button,

    fileName

  ) {



    if (

      !canvas ||

      !button

    ) {



      console.error(

        'K.NOAH EXPORT: canvas or button missing.'

      );



      return;



    }





    /* ==========================================================

       MOBILE WINDOW MUST OPEN IMMEDIATELY

       ========================================================== */



    var mobileDownloadWindow =

      null;





    if (

      knIsMobileDownload()

    ) {



      mobileDownloadWindow =

        knOpenMobileDownloadWindow();



    }





    /* ==========================================================

       BUTTON STATE

       ========================================================== */



    var oldButtonHTML =

      button.innerHTML;





    button.disabled =

      true;





    button.classList.add(

      'is-loading'

    );





    button.innerHTML =

      '<span>CREATING...</span>';





    var restoreImages =

      null;





    try {





      /* ========================================================

         1. LOAD RENDERER

         ======================================================== */



      var htmlToImage =

        await loadHtmlToImage();





      /* ========================================================

         2. REAL LAYOUT SIZE

         ======================================================== */



      var sourceWidth =

        canvas.offsetWidth;





      var sourceHeight =

        canvas.offsetHeight;





      if (

        !sourceWidth ||

        !sourceHeight

      ) {



        var rect =

          canvas.getBoundingClientRect();





        sourceWidth =

          Math.round(

            rect.width

          );





        sourceHeight =

          Math.round(

            rect.height

          );



      }





      if (

        !sourceWidth ||

        !sourceHeight

      ) {



        throw new Error(

          'Could not determine canvas size.'

        );



      }





      console.log(

        'K.NOAH EXPORT — source size:',

        sourceWidth +

        ' × ' +

        sourceHeight

      );





      /* ========================================================

         3. OPTIONAL IMAGES

         ======================================================== */



      restoreImages =

        neutralizeBrokenImages(

          canvas

        );





      await nextPaint();





      /* ========================================================

         4. RENDER REAL DOM

         ======================================================== */



      var renderedDataUrl =

        await htmlToImage.toPng(

          canvas,

          {



            width:

              sourceWidth,



            height:

              sourceHeight,



            canvasWidth:

              sourceWidth * 2,



            canvasHeight:

              sourceHeight * 2,



            pixelRatio:

              2,



            backgroundColor:

              '#e9e9e7',



            cacheBust:

              false,



            includeQueryParams:

              true,



            imagePlaceholder:

              TRANSPARENT_PIXEL,



            skipAutoScale:

              true,



            filter:

              exportFilter,



            style: {



              position:

                'relative',



              left:

                '0',



              right:

                'auto',



              top:

                '0',



              bottom:

                'auto',



              width:

                sourceWidth + 'px',



              height:

                sourceHeight + 'px',



              maxWidth:

                'none',



              maxHeight:

                'none',



              minWidth:

                '0',



              minHeight:

                '0',



              margin:

                '0',



              padding:

                '0',



              transform:

                'none',



              transformOrigin:

                'top left',



              overflow:

                'visible'



            }



          }

        );





      /* ========================================================

         5. FLATTEN RESULT

         ======================================================== */



      var renderedImage =

        await loadRenderedImage(

          renderedDataUrl

        );





      console.log(

        'K.NOAH EXPORT — rendered:',

        renderedImage.width +

        ' × ' +

        renderedImage.height

      );





      /* ========================================================

         6. FINAL CANVAS

         ======================================================== */



      var output =

        document.createElement(

          'canvas'

        );





      output.width =

        FINAL_WIDTH;





      output.height =

        FINAL_HEIGHT;





      var ctx =

        output.getContext(

          '2d'

        );





      if (!ctx) {



        throw new Error(

          'Could not create export canvas.'

        );



      }





      /* ========================================================

         7. BACKGROUND

         ======================================================== */



      ctx.fillStyle =

        '#e9e9e7';





      ctx.fillRect(

        0,

        0,

        FINAL_WIDTH,

        FINAL_HEIGHT

      );





      /* ========================================================

         8. AVAILABLE AREA

         ======================================================== */



      var availableWidth =

        FINAL_WIDTH -

        (

          FINAL_PADDING *

          2

        );





      var availableHeight =

        FINAL_HEIGHT -

        (

          FINAL_PADDING *

          2

        );





      /* ========================================================

         9. PROPORTIONAL SCALE

         ======================================================== */



      var scale =

        Math.min(



          availableWidth /

          renderedImage.width,



          availableHeight /

          renderedImage.height



        );





      var drawWidth =

        renderedImage.width *

        scale;





      var drawHeight =

        renderedImage.height *

        scale;





      /* ========================================================

         10. CENTER

         ======================================================== */



      var drawX =

        (

          FINAL_WIDTH -

          drawWidth

        ) / 2;





      var drawY =

        (

          FINAL_HEIGHT -

          drawHeight

        ) / 2;





      /* ========================================================

         11. DRAW

         ======================================================== */



      ctx.imageSmoothingEnabled =

        true;





      ctx.imageSmoothingQuality =

        'high';





      ctx.drawImage(



        renderedImage,



        drawX,

        drawY,



        drawWidth,

        drawHeight



      );





      /* ========================================================

         12. FINAL PNG

         ======================================================== */



      var finalDataUrl =

        output.toDataURL(

          'image/png',

          1

        );





      /* ========================================================

         13. OUTPUT

         ======================================================== */



      if (

        knIsMobileDownload()

      ) {



        /*

          MOBILE:

          Put finished PNG into the window that was

          already opened during the user's click.

        */



        knShowMobileImage(

          mobileDownloadWindow,

          finalDataUrl,

          fileName

        );



      } else {



        /*

          DESKTOP:

          Keep existing working download behavior.

        */



        saveFile(

          finalDataUrl,

          fileName

        );



      }





    } catch (error) {





      console.error(

        'K.NOAH EXPORT V4:',

        error

      );





      if (

        error &&

        error.target

      ) {



        console.error(

          'K.NOAH EXPORT — failing element:',

          error.target

        );



      }





      if (

        mobileDownloadWindow &&

        !mobileDownloadWindow.closed

      ) {



        knShowMobileError(

          mobileDownloadWindow

        );



      } else {



        alert(

          'The design could not be created. ' +

          'Please check the browser console.'

        );



      }





    } finally {





      if (

        restoreImages

      ) {



        restoreImages();



      }





      button.disabled =

        false;





      button.classList.remove(

        'is-loading'

      );





      button.innerHTML =

        oldButtonHTML;



    }



  }





  /* ============================================================

     JERSEY BUTTON

     ============================================================ */



  function setupJerseyButton() {



    var root =

      document.getElementById(

        'frx-configurator'

      );





    if (!root) {

      return false;

    }





    var preview =

      root.querySelector(

        ':scope > .frx-preview'

      );





    var canvas =

      getJerseyCanvas();





    if (

      !preview ||

      !canvas

    ) {

      return false;

    }





    preview.classList.add(

      'kn-download-host'

    );





    var existing =

      preview.querySelector(

        ':scope > .kn-live-download[data-kn-download="jersey"]'

      );





    if (existing) {

      return true;

    }





    var button =

      createButton(

        'jersey'

      );





    preview.appendChild(

      button

    );





    button.addEventListener(

      'click',

      function (event) {



        event.preventDefault();

        event.stopPropagation();





        exportCanvas(



          getJerseyCanvas(),



          button,



          'KNOAH-FRX-JERSEY.png'



        );



      }

    );





    return true;



  }





  /* ============================================================

     PANTS BUTTON

     ============================================================ */



  function setupPantsButton() {



    var preview =

      document.getElementById(

        'kn-pants-preview'

      );





    var canvas =

      getPantsCanvas();





    if (

      !preview ||

      !canvas

    ) {

      return false;

    }





    preview.classList.add(

      'kn-download-host'

    );





    var existing =

      preview.querySelector(

        ':scope > .kn-live-download[data-kn-download="pants"]'

      );





    if (existing) {

      return true;

    }





    var button =

      createButton(

        'pants'

      );





    preview.appendChild(

      button

    );





    button.addEventListener(

      'click',

      function (event) {



        event.preventDefault();

        event.stopPropagation();





        exportCanvas(



          getPantsCanvas(),



          button,



          'KNOAH-FRX-PANTS.png'



        );



      }

    );





    return true;



  }
    /* ============================================================

     CLEAN OLD DOWNLOAD NAVIGATION

     ============================================================ */



  function cleanOldDownloadNavigation() {



    document

      .querySelectorAll(

        '#kn-part-switch-inner [data-kn-part="download"]'

      )

      .forEach(

        function (element) {



          element.remove();



        }

      );





    var oldPage =

      document.getElementById(

        'kn-download-design-page'

      );





    if (

      oldPage &&

      !oldPage.querySelector(

        '.frx-canvas, #kn-pants-canvas'

      )

    ) {



      oldPage.remove();



    }



  }





  /* ============================================================

     QUOTE LABEL

     ============================================================ */



  function updateQuoteLabel() {



    var button =

      document.querySelector(

        '#kn-part-switch-inner [data-kn-part="review"]'

      );





    if (!button) {

      return;

    }





    button.textContent =

      'GET YOUR QUOTE';



  }





  /* ============================================================

     STYLES

     ============================================================ */



  function addStyles() {



    if (

      document.getElementById(

        'kn-live-export-v4-style'

      )

    ) {

      return;

    }





    var style =

      document.createElement(

        'style'

      );





    style.id =

      'kn-live-export-v4-style';





    style.textContent = `



      /* =====================================================

         HOST

         ===================================================== */



      .kn-download-host{

        position:relative !important;

      }





      /* =====================================================

         DOWNLOAD BUTTON

         ===================================================== */



      .kn-live-download{



        position:absolute !important;



        top:18px !important;

        right:18px !important;



        z-index:999999 !important;



        display:flex !important;



        align-items:center !important;

        justify-content:center !important;



        gap:8px !important;



        height:42px !important;

        min-width:42px !important;



        padding:0 13px !important;

        margin:0 !important;



        border:

          1px solid rgba(0,0,0,.14) !important;



        border-radius:

          9px !important;



        background:

          rgba(255,255,255,.94) !important;



        color:

          #111 !important;



        box-shadow:

          0 5px 18px rgba(0,0,0,.08) !important;



        backdrop-filter:

          blur(8px) !important;



        -webkit-backdrop-filter:

          blur(8px) !important;



        font-family:

          inherit !important;



        font-size:

          9px !important;



        line-height:

          1 !important;



        font-weight:

          900 !important;



        letter-spacing:

          .08em !important;



        cursor:

          pointer !important;



        transition:

          transform .18s ease,

          background .18s ease,

          color .18s ease,

          box-shadow .18s ease !important;



      }





      .kn-live-download svg{



        display:block !important;



        width:17px !important;

        height:17px !important;



        flex:0 0 17px !important;



      }





      .kn-live-download:hover{



        transform:

          translateY(-1px) !important;



        background:

          #111 !important;



        color:

          #fff !important;



        box-shadow:

          0 8px 24px rgba(0,0,0,.14) !important;



      }





      .kn-live-download.is-loading{



        min-width:

          112px !important;



        opacity:

          .65 !important;



        pointer-events:

          none !important;



      }





      /* =====================================================

         DESKTOP NAVIGATION

         ===================================================== */



      @media(min-width:901px){



        #kn-part-switch-inner{



          display:grid !important;



          grid-template-columns:

            repeat(3,minmax(0,1fr)) !important;



          width:100% !important;



        }





        #kn-part-switch-inner

        > [data-kn-part]{



          width:100% !important;



          min-width:0 !important;

          max-width:none !important;



          margin:0 !important;



          box-sizing:

            border-box !important;



          white-space:

            nowrap !important;



        }



      }





      /* =====================================================

         MOBILE

         ===================================================== */



      @media(max-width:900px){



        #frx-configurator > .frx-preview,

        #kn-pants-preview{



          position:

            relative !important;



        }





        #frx-configurator

        > .frx-preview

        > .kn-live-download,



        #kn-pants-preview

        > .kn-live-download{



          position:

            absolute !important;



          top:

            10px !important;



          right:

            10px !important;



          left:

            auto !important;



          bottom:

            auto !important;



          z-index:

            999999 !important;



          display:

            flex !important;



          align-items:

            center !important;



          justify-content:

            center !important;



          width:

            40px !important;



          min-width:

            40px !important;



          max-width:

            40px !important;



          height:

            40px !important;



          min-height:

            40px !important;



          padding:

            0 !important;



          margin:

            0 !important;



          border:

            1px solid rgba(0,0,0,.12) !important;



          border-radius:

            9px !important;



          background:

            rgba(255,255,255,.96) !important;



          color:

            #111 !important;



          box-shadow:

            0 4px 14px rgba(0,0,0,.10) !important;



          transform:

            none !important;



        }





        #frx-configurator

        > .frx-preview

        > .kn-live-download svg,



        #kn-pants-preview

        > .kn-live-download svg{



          display:

            block !important;



          width:

            18px !important;



          height:

            18px !important;



          flex:

            0 0 18px !important;



        }





        #frx-configurator

        > .frx-preview

        > .kn-live-download span,



        #kn-pants-preview

        > .kn-live-download span{



          display:

            none !important;



        }





        .kn-live-download.is-loading{



          width:

            40px !important;



          min-width:

            40px !important;



          max-width:

            40px !important;



          opacity:

            .65 !important;



        }





        .kn-live-download.is-loading::after{



          content:

            "" !important;



          display:

            block !important;



          width:

            15px !important;



          height:

            15px !important;



          border:

            2px solid rgba(0,0,0,.18) !important;



          border-top-color:

            #111 !important;



          border-radius:

            50% !important;



          animation:

            kn-mobile-export-spin .7s linear infinite !important;



        }





        .kn-live-download.is-loading svg{



          display:

            none !important;



        }



      }





      @keyframes kn-mobile-export-spin{



        from{

          transform:rotate(0deg);

        }



        to{

          transform:rotate(360deg);

        }



      }



    `;





    document.head.appendChild(

      style

    );



  }





  /* ============================================================

     MOBILE BUTTON FIX

     ============================================================ */



  function fixMobileButtons() {



    if (

      !window.matchMedia(

        '(max-width: 900px)'

      ).matches

    ) {

      return;

    }





    var jerseyPreview =

      document.querySelector(

        '#frx-configurator > .frx-preview'

      );





    if (jerseyPreview) {



      jerseyPreview.classList.add(

        'kn-mobile-download-ready'

      );



    }





    var pantsPreview =

      document.getElementById(

        'kn-pants-preview'

      );





    if (pantsPreview) {



      pantsPreview.classList.add(

        'kn-mobile-download-ready'

      );



    }



  }
    /* ============================================================

     INSTALL

     ============================================================ */



  function install() {



    cleanOldDownloadNavigation();



    updateQuoteLabel();



    addStyles();



    fixMobileButtons();





    var jerseyReady =

      setupJerseyButton();





    var pantsReady =

      setupPantsButton();





    return (

      jerseyReady &&

      pantsReady

    );



  }





  /* ============================================================

     BOUNDED RETRY

     ============================================================ */



  var installAttempts =

    0;



  var MAX_INSTALL_ATTEMPTS =

    80;





  function tryInstall() {



    installAttempts +=

      1;





    var ready =

      install();





    if (

      ready ||

      installAttempts >=

      MAX_INSTALL_ATTEMPTS

    ) {



      return;



    }





    window.setTimeout(

      tryInstall,

      250

    );



  }





  /* ============================================================

     RESIZE

     ============================================================ */



  var resizeTimer =

    null;





  window.addEventListener(

    'resize',

    function () {



      window.clearTimeout(

        resizeTimer

      );





      resizeTimer =

        window.setTimeout(

          function () {



            fixMobileButtons();



          },

          120

        );



    }

  );





  /* ============================================================

     START

     ============================================================ */



  if (

    document.readyState ===

    'loading'

  ) {



    document.addEventListener(

      'DOMContentLoaded',

      tryInstall,

      {

        once:

          true

      }

    );



  } else {



    tryInstall();



  }





})();
/* ============================================================
   K.NOAH — HIDE DOWNLOAD ON MOBILE
   Desktop download remains unchanged
   ============================================================ */

(function () {
  'use strict';

  function hideMobileDownloads() {
    if (!window.matchMedia('(max-width: 900px)').matches) {
      return;
    }

    document
      .querySelectorAll('.kn-live-download')
      .forEach(function (button) {
        button.style.setProperty('display', 'none', 'important');
      });
  }

  hideMobileDownloads();

  document.addEventListener('DOMContentLoaded', hideMobileDownloads);

  window.setTimeout(hideMobileDownloads, 500);
  window.setTimeout(hideMobileDownloads, 1500);
  window.setTimeout(hideMobileDownloads, 3000);

})();